import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslationDirective } from '../../../shared/translation-directive';

@Component({
  selector: 'upu-something-went-wrong',
  imports: [TranslationDirective, MatButtonModule, RouterLink, MatIcon],
  host: {
    class:
      'min-h-[calc(100vh-36px)] pt-24 flex flex-col items-center justify-center ',
  },
  templateUrl: './something-went-wrong.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SomethingWentWrong {
  private readonly location = inject(Location);

  protected goBack(): void {
    this.location.back();
  }
}
